import script from "./NotificationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationItem.vue?vue&type=script&setup=true&lang=js"

import "./NotificationItem.vue?vue&type=style&index=0&id=30de6b68&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30de6b68"]])

export default __exports__